import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../organisms/PageHeader';
import { ClientNavigation, ClientNavigationPage, INavigations, mapNavigationsToProps } from '../../organisms/client/ClientNavigation';
import { IPaginatedReportData } from "../../../entities/reports/IReportData";
import { IData as ClientListData } from "../../../store/client/clientList";
import { FetchState } from '../../../entities/FetchState';
import { ClientList as ClientListOrganism } from '../../organisms/client/ClientList';

// CSS
const useStyles = makeStyles((theme: Theme) =>
    createStyles({}),
); 

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    list: IPaginatedReportData<ClientListData>;
    searchTerm: string | null;
}

// Outgoing functions to Dispatch
interface IDispatchProps {
    navigations: INavigations;
    onLoadList: (search?: string) => void;
    onClickDetails: (client: ClientListData) => void,
    onClickEdit: (client: ClientListData) => void,
    onSearch: (searchTerm: string) => void,
    onLoadMore: () => void,
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    list: state.client.clientList.ClientList,
    searchTerm: state.client.clientList.SearchTerm,
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    navigations: mapNavigationsToProps(dispatch),
    onLoadList: (search?: string) => dispatch(RootActionCreators.Client.clientList.FetchData(search)),
    onClickDetails: (client: ClientListData) => dispatch(RootActionCreators.Navigate.ToClientDetail(client.streamId)),
    onClickEdit: (client: ClientListData) => dispatch(RootActionCreators.Navigate.ToClientEdit(client.streamId)),
    onSearch: (searchTerm: string) => {
        dispatch(RootActionCreators.Client.clientList.SetSearchTerm(searchTerm));
        dispatch(RootActionCreators.Client.clientList.FetchData(searchTerm));
    },
    onLoadMore: () => dispatch(RootActionCreators.Client.clientList.LoadMore()),
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const ClientList = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tClient } = useTranslation('client');

    const refresh = () => { 
        props.onLoadList(props.searchTerm || undefined);
    }
    
    // Load the list when the component mounts
    React.useEffect(() => {
        refresh();
    }, []);

    return <ClientNavigation selected={ClientNavigationPage.List} navigations={props.navigations}>
            
        <PageHeader
            title={tClient('title')}
            subTitle={tClient('subtitle')}
            explainText={tClient('explainText')}
        />

        <ClientListOrganism
            data={props.list}
            loading={props.list.state !== FetchState.Success && props.list.state !== FetchState.Error}
            hasError={props.list.state === FetchState.Error}
            errorDetails={props.list.errorMessage}
            onClickDetails={props.onClickDetails}
            onClickEdit={props.onClickEdit}
            onRefresh={refresh}
            onSearch={props.onSearch}
            onLoadMore={props.onLoadMore}
            title={tClient('listTitle')}
        />

        </ClientNavigation>
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientList);

